import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Table
} from 'react-lib/frameworks/Table'
import {
  Checkbox,
  Button,
  Dropdown,
  Input,
  Form,
  FormGroup,
  FormField,
  Accordion,
  AccordionTitle,
  AccordionContent,
  Icon
} from 'semantic-ui-react'

const CardWaitingListUX = (props: any) => {
    return(
      <div
        id="CardWaitingListUX-div-0">
        
        <Form
          className="small"
          id="CardWaitingListUX-Form-43">
          <FormGroup
            id="CardWaitingListUX-FormGroup-44"
            inline={true}
            style={{margin: "0.75rem 0"}}>
            <FormField
              id="CardWaitingListUX-FormField-46"
              inline={true}
              style={{padding:  "0 0.75rem"}}
              width={11}>
              <label
                id="CardWaitingListUX-label-55">
                {props.languageUX === "en" ? "clinic" : "คลินิก"}
              </label>
              <Dropdown
                fluid={true}
                id="CardWaitingListUX-Dropdown-53"
                onChange={props.onChangeWaitingListDivision}
                options={props.divisionHasWaitingListOptions}
                search={true}
                selection={true}
                style={{width: "100%"}}
                value={props.selectedWaitingListDivisionId??""}>
              </Dropdown>
            </FormField>
            <FormField
              id="CardWaitingListUX-FormField-54"
              inline={true}
              style={{minWidth: "14.9rem"}}>
              <Button
                color="teal"
                content="สรุปรายชื่อเข้าคิว"
                icon="right arrow"
                id="CardWaitingListUX-Button-60"
                labelPosition="right"
                onClick={props.onClickSummaryQueueList}>
                
              </Button>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardWaitingListUX-FormGroup-45"
            inline={true}
            style={{marginBottom: "0.75rem"}}>
            <FormField
              id="CardWaitingListUX-FormField-47"
              inline={true}
              style={{padding:0, paddingLeft: "0.5rem"}}
              width={11}>
              <Input
                fluid={true}
                icon="filter"
                id="CardWaitingListUX-Input-50"
                onChange={props.onChangeWaitingListSearch}
                placeholder="ระบุชื่อ WaitingList"
                style={{marginRight: "10px" , width: "100%"}}
                value={props.waitingListSearch}>
              </Input>
            </FormField>
            <FormField
              id="CardWaitingListUX-FormField-48"
              style={{padding:0}}>
              <Button
                color="blue"
                icon="refresh"
                id="CardWaitingListUX-Button-51"
                loading={props.waitingListLoading}
                onClick={props.onRefresh}
                size="small"
                style={{marginRight: "10px"}}>
              </Button>
            </FormField>
            <FormField
              id="CardWaitingListUX-FormField-49"
              style={{paddingRight:"0.5rem", minWidth: "max-content"}}>
              <Button
                color="blue"
                id="CardWaitingListUX-Button-52"
                onClick={props.onNewWaitingList}
                size="small"
                style={{...(props.hiddenCreateWaitingList && {display: "none"})}}>
                {props.languageUX === "en" ? "Create a Waiting List" : "สร้าง Waiting List"}
              </Button>
            </FormField>
          </FormGroup>
        </Form>
        <Table
          NoDataComponent={() => null}
          data={props.filterWaitingList}
          getTrProps={props.waitingListRowProps}
          headers="ชื่อ Waiting List, ผู้ป่วยรอทำนัดหมาย,ผู้ป่วยทั้งหมด"
          id="CardWaitingListUX-Table-1"
          keys="name,pending,patient_count"
          minRows="5"
          showPagination={false}
          style={{height: "25vh"}}>
        </Table>
        <div
          id="CardWaitingListUX-div-3"
          style={{display: "flex", margin:"15px 0 15px 0", justifyContent: "space-between", alignItems: "center"}}>
          
          <div
            id="CardWaitingListUX-div-28"
            style={{display: "flex"}}>
            
            <div
              id="CardWaitingListUX-div-14"
              style={{fontSize: "1.2rem", fontWeight: "bold"}}>
              รายชื่อผู้ป่วย : 
            </div>
            <div
              id="CardWaitingListUX-div-19"
              style={{fontSize: "1.2rem", fontWeight: "bold", paddingLeft: "5px"}}>
              { props.selectedWaitingListName}
            </div>
          </div>
          <div
            id="CardWaitingListUX-div-34">
            
            <Button
              color="orange"
              disabled={props.disableWaitingListManage}
              id="CardWaitingListUX-Button-35"
              onClick={props.setShowModStatic}
              size="tiny">
              {props.languageUX === "en" ? "statistics" : "สถิติ"}
            </Button>
            <Button
              color="blue"
              disabled={props.disableWaitingListManage}
              id="CardWaitingListUX-Button-36"
              onClick={props.onShowModWaitingList}
              size="tiny">
              {props.languageUX === "en" ? "manage" : "จัดการ"}
            </Button>
          </div>
        </div>
        <div
          id="CardWaitingListUX-div-20"
          style={{display: "flex",justifyContent: "flex-start", alignItems:"flex-start "}}>
          
          <div
            id="CardWaitingListUX-div-21"
            style={{paddingRight: "10px"}}>
            
            <div
              id="CardWaitingListUX-div-25">
              {props.languageUX === "en" ? "Name - Surname / HN" : "ชื่อ - สกุล / HN"}
            </div>
            <Input
              disabled={props.disabledFilter}
              icon="filter"
              id="CardWaitingListUX-Input-30"
              onChange={props.onSearchPatientNameBox}
              value={props.searchPatientNameBox}>
            </Input>
          </div>
          <div
            id="CardWaitingListUX-div-22"
            style={{paddingRight: "10px"}}>
            
            <div
              id="CardWaitingListUX-div-24">
              {props.languageUX === "en" ? "status" : "สถานะ"}
            </div>
            <Dropdown
              disabled={props.disabledFilter}
              id="CardWaitingListUX-Dropdown-27"
              onChange={props.onSelectedStatus}
              options={props.statusOptions}
              selection={true}
              value={props.selectedStatus}>
            </Dropdown>
          </div>
          <div
            id="CardWaitingListUX-div-40"
            style={{paddingRight: "10px"}}>
            
            <div
              id="CardWaitingListUX-div-41">
              {props.languageUX === "en" ? "Doctor / Student" : "แพทย์ / นิสิต"}
            </div>
            <Dropdown
              disabled={props.disabledFilterDoctor}
              id="CardWaitingListUX-Dropdown-42"
              onChange={props.onChangeFilterSelectedDoctor}
              options={props.filterDoctorOptions}
              selection={true}
              value={props.filterSelectedDoctor}>
            </Dropdown>
          </div>
          <div
            id="CardWaitingListUX-div-29"
            style={{display: "none", justifyContent: "center",alignSelf:"flex-end", padding: "5px 10px"}}>
            
            <Button
              color="brown"
              id="CardWaitingListUX-Button-23">
              {props.languageUX === "en" ? "Search" : "ค้นหา"}
            </Button>
          </div>
        </div>
        <div
          id="CardWaitingListUX-div-8"
          style={{display: "none", justifyContent: "space-between", alignItems: "center", padding: "20px 0px 10px 0px"}}>
          
          <Checkbox
            checked={props.isAppointed}
            disabled={props.disabledFilter}
            id="CardWaitingListUX-Checkbox-9"
            label={props.languageUX === "en" ? "Show only patients with appointments" : "แสดงเฉพาะผู้ป่วยที่มีนัดหมายแล้ว"}
            onClick={props.toggleIsAppointed}
            style={{display: "none"}}>
          </Checkbox>
        </div>
        <Table
          NoDataComponent={() => null}
          data={props.waitingListItems}
          getTrProps={props.waitingListItemRowProps}
          headers="ชื่อ-สกุล,เบอร์โทรติดต่อ,คลินิก,แพทย์/นิสิต,สถานะ"
          id="CardWaitingListUX-Table-2"
          keys="patient_name_with_hn,patient_tel,division_name,provider_name,status_name"
          minRows="5"
          showPagination={false}
          style={{height: "25vh",margin:"10px 0px"}}
          widths={props.patientListTableWidths}>
        </Table>
        <Accordion
          fluid={true}
          id="CardWaitingListUX-Accordion-56">
          <AccordionTitle
            active={props.openAccordionAppointment}
            id="CardWaitingListUX-AccordionTitle-57"
            onClick={props.accordionAppointmentOnClick}
            style={{paddingTop: "0"}}>
            <div
              id="CardWaitingListUX-div-11"
              style={{display: "flex", alignItems: "center", justifyContent: "space-between", fontSize: "1.2rem", fontWeight: "bold"}}>
              {}
              <div
                id="CardWaitingListUX-div-37"
                style={{display:"flex", gap:"10px"}}>
                
                <Icon
                  color={props.selectedAppointment ?  "grey" : undefined}
                  id="CardWaitingListUX-Icon-59"
                  name="dropdown">
                </Icon>
                <div
                  id="CardWaitingListUX-div-38">
                  {props.languageUX === "en" ? "Previous appointment" : "นัดหมายก่อนหน้า"}
                </div>
                <div
                  id="CardWaitingListUX-div-39">
                  {props.selectedName }
                </div>
              </div>
              <Button
                color="orange"
                disabled={props.disabledCreatePatientAppointment}
                id="CardWaitingListUX-Button-13"
                onClick={props.createPatientAppointment}
                size="small">
                {props.languageUX === "en" ? "Add appointment from waiting list" : "เพิ่มนัดหมายจาก waiting list"}
              </Button>
            </div>
          </AccordionTitle>
          <AccordionContent
            active={props.openAccordionAppointment}
            id="CardWaitingListUX-AccordionContent-58">
            <Table
              NoDataComponent={() => null}
              data={props.appointmentList}
              getTrProps={props.appointmentRowProps}
              headers="ชื่อ-สกุล,คลินิก,แพทย์/นิสิต,ประเภทนัดหมาย,Waiting List,วันเวลานัดหมาย"
              id="CardWaitingListUX-Table-12"
              keys="patient_name,display_info_division_name,display_info_provider_name,type_display,waiting_list_name,display_info_start_datetime_iso"
              minRows="4"
              showPagination={false}
              style={{height: "30vh"}}
              widths="^50,^50,^50,^50,^50,^50">
            </Table>
          </AccordionContent>
        </Accordion>
      </div>
    )
}


export default CardWaitingListUX

export const screenPropsDefault = {"patientSelector":"[Patient Selector]"}

/* Date Time : Wed Oct 01 2025 12:23:45 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardWaitingListUX-div-0"
        }
      },
      "seq": 0
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 1,
      "name": "Table",
      "parent": 0,
      "props": {
        "NoDataComponent": {
          "type": "code",
          "value": "() => null"
        },
        "data": {
          "type": "code",
          "value": "props.filterWaitingList"
        },
        "getTrProps": {
          "type": "code",
          "value": "props.waitingListRowProps"
        },
        "headers": {
          "type": "value",
          "value": "ชื่อ Waiting List, ผู้ป่วยรอทำนัดหมาย,ผู้ป่วยทั้งหมด"
        },
        "id": {
          "type": "value",
          "value": "CardWaitingListUX-Table-1"
        },
        "keys": {
          "type": "value",
          "value": "name,pending,patient_count"
        },
        "minRows": {
          "type": "value",
          "value": "5"
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "style": {
          "type": "code",
          "value": "{height: \"25vh\"}"
        }
      },
      "seq": 4,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 2,
      "name": "Table",
      "parent": 0,
      "props": {
        "NoDataComponent": {
          "type": "code",
          "value": "() => null"
        },
        "data": {
          "type": "code",
          "value": "props.waitingListItems"
        },
        "getTrProps": {
          "type": "code",
          "value": "props.waitingListItemRowProps",
          "valueEN": ""
        },
        "headers": {
          "type": "value",
          "value": "ชื่อ-สกุล,เบอร์โทรติดต่อ,คลินิก,แพทย์/นิสิต,สถานะ"
        },
        "id": {
          "type": "value",
          "value": "CardWaitingListUX-Table-2"
        },
        "keys": {
          "type": "value",
          "value": "patient_name_with_hn,patient_tel,division_name,provider_name,status_name"
        },
        "minRows": {
          "type": "value",
          "value": "5"
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "style": {
          "type": "code",
          "value": "{height: \"25vh\",margin:\"10px 0px\"}"
        },
        "widths": {
          "type": "code",
          "value": "props.patientListTableWidths"
        }
      },
      "seq": 16,
      "void": false
    },
    {
      "from": null,
      "id": 3,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardWaitingListUX-div-3"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", margin:\"15px 0 15px 0\", justifyContent: \"space-between\", alignItems: \"center\"}"
        }
      },
      "seq": 8,
      "void": false
    },
    {
      "from": null,
      "id": 8,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardWaitingListUX-div-8"
        },
        "style": {
          "type": "code",
          "value": "{display: \"none\", justifyContent: \"space-between\", alignItems: \"center\", padding: \"20px 0px 10px 0px\"}"
        }
      },
      "seq": 12,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 9,
      "name": "Checkbox",
      "parent": 8,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.isAppointed"
        },
        "disabled": {
          "type": "code",
          "value": "props.disabledFilter"
        },
        "id": {
          "type": "value",
          "value": "CardWaitingListUX-Checkbox-9"
        },
        "label": {
          "type": "value",
          "value": "แสดงเฉพาะผู้ป่วยที่มีนัดหมายแล้ว",
          "valueEN": "Show only patients with appointments"
        },
        "onChange": {
          "type": "code",
          "value": ""
        },
        "onClick": {
          "type": "code",
          "value": "props.toggleIsAppointed"
        },
        "style": {
          "type": "code",
          "value": "{display: \"none\"}"
        }
      },
      "seq": 9,
      "void": false
    },
    {
      "from": null,
      "id": 11,
      "name": "div",
      "parent": 57,
      "props": {
        "children": {
          "type": "code",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardWaitingListUX-div-11"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", justifyContent: \"space-between\", fontSize: \"1.2rem\", fontWeight: \"bold\"}"
        }
      },
      "seq": 59,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 12,
      "name": "Table",
      "parent": 58,
      "props": {
        "NoDataComponent": {
          "type": "code",
          "value": "() => null"
        },
        "data": {
          "type": "code",
          "value": "props.appointmentList"
        },
        "getTrProps": {
          "type": "code",
          "value": "props.appointmentRowProps"
        },
        "headers": {
          "type": "value",
          "value": "ชื่อ-สกุล,คลินิก,แพทย์/นิสิต,ประเภทนัดหมาย,Waiting List,วันเวลานัดหมาย"
        },
        "id": {
          "type": "value",
          "value": "CardWaitingListUX-Table-12"
        },
        "keys": {
          "type": "value",
          "value": "patient_name,display_info_division_name,display_info_provider_name,type_display,waiting_list_name,display_info_start_datetime_iso"
        },
        "minRows": {
          "type": "value",
          "value": "4"
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "style": {
          "type": "code",
          "value": "{height: \"30vh\"}"
        },
        "widths": {
          "type": "value",
          "value": "^50,^50,^50,^50,^50,^50"
        }
      },
      "seq": 56,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 13,
      "name": "Button",
      "parent": 11,
      "props": {
        "children": {
          "type": "value",
          "value": "เพิ่มนัดหมายจาก waiting list",
          "valueEN": "Add appointment from waiting list"
        },
        "color": {
          "type": "value",
          "value": "orange"
        },
        "disabled": {
          "type": "code",
          "value": "props.disabledCreatePatientAppointment"
        },
        "id": {
          "type": "value",
          "value": "CardWaitingListUX-Button-13"
        },
        "onClick": {
          "type": "code",
          "value": "props.createPatientAppointment"
        },
        "size": {
          "type": "value",
          "value": "small"
        }
      },
      "seq": 60,
      "void": false
    },
    {
      "from": null,
      "id": 14,
      "name": "div",
      "parent": 28,
      "props": {
        "children": {
          "type": "value",
          "value": "รายชื่อผู้ป่วย : "
        },
        "id": {
          "type": "value",
          "value": "CardWaitingListUX-div-14"
        },
        "style": {
          "type": "code",
          "value": "{fontSize: \"1.2rem\", fontWeight: \"bold\"}"
        }
      },
      "seq": 14,
      "void": false
    },
    {
      "from": null,
      "id": 19,
      "name": "div",
      "parent": 28,
      "props": {
        "children": {
          "type": "code",
          "value": " props.selectedWaitingListName"
        },
        "id": {
          "type": "value",
          "value": "CardWaitingListUX-div-19"
        },
        "style": {
          "type": "code",
          "value": "{fontSize: \"1.2rem\", fontWeight: \"bold\", paddingLeft: \"5px\"}"
        }
      },
      "seq": 15,
      "void": false
    },
    {
      "from": null,
      "id": 20,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardWaitingListUX-div-20"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\",justifyContent: \"flex-start\", alignItems:\"flex-start \"}"
        }
      },
      "seq": 11,
      "void": false
    },
    {
      "from": null,
      "id": 21,
      "name": "div",
      "parent": 20,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardWaitingListUX-div-21"
        },
        "style": {
          "type": "code",
          "value": "{paddingRight: \"10px\"}"
        }
      },
      "seq": 21,
      "void": false
    },
    {
      "from": null,
      "id": 22,
      "name": "div",
      "parent": 20,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardWaitingListUX-div-22"
        },
        "style": {
          "type": "code",
          "value": "{paddingRight: \"10px\"}"
        }
      },
      "seq": 22,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 23,
      "name": "Button",
      "parent": 29,
      "props": {
        "children": {
          "type": "value",
          "value": "ค้นหา",
          "valueEN": "Search"
        },
        "color": {
          "type": "value",
          "value": "brown"
        },
        "id": {
          "type": "value",
          "value": "CardWaitingListUX-Button-23"
        }
      },
      "seq": 23,
      "void": false
    },
    {
      "from": null,
      "id": 24,
      "name": "div",
      "parent": 22,
      "props": {
        "children": {
          "type": "value",
          "value": "สถานะ",
          "valueEN": "status"
        },
        "id": {
          "type": "value",
          "value": "CardWaitingListUX-div-24"
        }
      },
      "seq": 24,
      "void": false
    },
    {
      "from": null,
      "id": 25,
      "name": "div",
      "parent": 21,
      "props": {
        "children": {
          "type": "value",
          "value": "ชื่อ - สกุล / HN",
          "valueEN": "Name - Surname / HN"
        },
        "id": {
          "type": "value",
          "value": "CardWaitingListUX-div-25"
        }
      },
      "seq": 25,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 27,
      "name": "Dropdown",
      "parent": 22,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.disabledFilter"
        },
        "id": {
          "type": "value",
          "value": "CardWaitingListUX-Dropdown-27"
        },
        "onChange": {
          "type": "code",
          "value": "props.onSelectedStatus"
        },
        "options": {
          "type": "code",
          "value": "props.statusOptions"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.selectedStatus"
        }
      },
      "seq": 27,
      "void": false
    },
    {
      "from": null,
      "id": 28,
      "name": "div",
      "parent": 3,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardWaitingListUX-div-28"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\"}"
        }
      },
      "seq": 19,
      "void": false
    },
    {
      "from": null,
      "id": 29,
      "name": "div",
      "parent": 20,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardWaitingListUX-div-29"
        },
        "style": {
          "type": "code",
          "value": "{display: \"none\", justifyContent: \"center\",alignSelf:\"flex-end\", padding: \"5px 10px\"}"
        }
      },
      "seq": 40,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 30,
      "name": "Input",
      "parent": 21,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.disabledFilter"
        },
        "icon": {
          "type": "value",
          "value": "filter"
        },
        "id": {
          "type": "value",
          "value": "CardWaitingListUX-Input-30"
        },
        "onChange": {
          "type": "code",
          "value": "props.onSearchPatientNameBox"
        },
        "value": {
          "type": "code",
          "value": "props.searchPatientNameBox"
        }
      },
      "seq": 30,
      "void": false
    },
    {
      "from": null,
      "id": 34,
      "name": "div",
      "parent": 3,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardWaitingListUX-div-34"
        }
      },
      "seq": 34,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 35,
      "name": "Button",
      "parent": 34,
      "props": {
        "children": {
          "type": "value",
          "value": "สถิติ",
          "valueEN": "statistics"
        },
        "color": {
          "type": "value",
          "value": "orange"
        },
        "disabled": {
          "type": "code",
          "value": "props.disableWaitingListManage"
        },
        "id": {
          "type": "value",
          "value": "CardWaitingListUX-Button-35"
        },
        "onClick": {
          "type": "code",
          "value": "props.setShowModStatic"
        },
        "size": {
          "type": "value",
          "value": "tiny"
        }
      },
      "seq": 35,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 36,
      "name": "Button",
      "parent": 34,
      "props": {
        "children": {
          "type": "value",
          "value": "จัดการ",
          "valueEN": "manage"
        },
        "color": {
          "type": "value",
          "value": "blue"
        },
        "disabled": {
          "type": "code",
          "value": "props.disableWaitingListManage"
        },
        "id": {
          "type": "value",
          "value": "CardWaitingListUX-Button-36"
        },
        "onClick": {
          "type": "code",
          "value": "props.onShowModWaitingList"
        },
        "size": {
          "type": "value",
          "value": "tiny"
        }
      },
      "seq": 36,
      "void": false
    },
    {
      "from": null,
      "id": 37,
      "name": "div",
      "parent": 11,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardWaitingListUX-div-37"
        },
        "style": {
          "type": "code",
          "value": "{display:\"flex\", gap:\"10px\"}"
        }
      },
      "seq": 38,
      "void": false
    },
    {
      "from": null,
      "id": 38,
      "name": "div",
      "parent": 37,
      "props": {
        "children": {
          "type": "value",
          "value": "นัดหมายก่อนหน้า",
          "valueEN": "Previous appointment"
        },
        "id": {
          "type": "value",
          "value": "CardWaitingListUX-div-38"
        }
      },
      "seq": 39,
      "void": false
    },
    {
      "from": null,
      "id": 39,
      "name": "div",
      "parent": 37,
      "props": {
        "children": {
          "type": "code",
          "value": "props.selectedName "
        },
        "id": {
          "type": "value",
          "value": "CardWaitingListUX-div-39"
        }
      },
      "seq": 43,
      "void": false
    },
    {
      "from": null,
      "id": 40,
      "name": "div",
      "parent": 20,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardWaitingListUX-div-40"
        },
        "style": {
          "type": "code",
          "value": "{paddingRight: \"10px\"}"
        }
      },
      "seq": 29,
      "void": false
    },
    {
      "from": null,
      "id": 41,
      "name": "div",
      "parent": 40,
      "props": {
        "children": {
          "type": "value",
          "value": "แพทย์ / นิสิต",
          "valueEN": "Doctor / Student"
        },
        "id": {
          "type": "value",
          "value": "CardWaitingListUX-div-41"
        }
      },
      "seq": 41,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 42,
      "name": "Dropdown",
      "parent": 40,
      "props": {
        "clearable": {
          "type": "code",
          "value": ""
        },
        "disabled": {
          "type": "code",
          "value": "props.disabledFilterDoctor"
        },
        "id": {
          "type": "value",
          "value": "CardWaitingListUX-Dropdown-42"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeFilterSelectedDoctor"
        },
        "onClose": {
          "type": "code",
          "value": ""
        },
        "options": {
          "type": "code",
          "value": "props.filterDoctorOptions"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.filterSelectedDoctor"
        }
      },
      "seq": 42,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 43,
      "name": "Form",
      "parent": 0,
      "props": {
        "className": {
          "type": "value",
          "value": "small"
        },
        "id": {
          "type": "value",
          "value": "CardWaitingListUX-Form-43"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 44,
      "name": "FormGroup",
      "parent": 43,
      "props": {
        "id": {
          "type": "value",
          "value": "CardWaitingListUX-FormGroup-44"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"0.75rem 0\"}"
        },
        "widths": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 44,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 45,
      "name": "FormGroup",
      "parent": 43,
      "props": {
        "id": {
          "type": "value",
          "value": "CardWaitingListUX-FormGroup-45"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{marginBottom: \"0.75rem\"}"
        },
        "widths": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 45,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 46,
      "name": "FormField",
      "parent": 44,
      "props": {
        "id": {
          "type": "value",
          "value": "CardWaitingListUX-FormField-46"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{padding:  \"0 0.75rem\"}"
        },
        "width": {
          "type": "code",
          "value": "11"
        }
      },
      "seq": 46,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 47,
      "name": "FormField",
      "parent": 45,
      "props": {
        "id": {
          "type": "value",
          "value": "CardWaitingListUX-FormField-47"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{padding:0, paddingLeft: \"0.5rem\"}"
        },
        "width": {
          "type": "code",
          "value": "11"
        }
      },
      "seq": 47,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 48,
      "name": "FormField",
      "parent": 45,
      "props": {
        "id": {
          "type": "value",
          "value": "CardWaitingListUX-FormField-48"
        },
        "style": {
          "type": "code",
          "value": "{padding:0}"
        }
      },
      "seq": 48,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 49,
      "name": "FormField",
      "parent": 45,
      "props": {
        "id": {
          "type": "value",
          "value": "CardWaitingListUX-FormField-49"
        },
        "style": {
          "type": "code",
          "value": "{paddingRight:\"0.5rem\", minWidth: \"max-content\"}"
        }
      },
      "seq": 49,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 50,
      "name": "Input",
      "parent": 47,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "icon": {
          "type": "value",
          "value": "filter"
        },
        "id": {
          "type": "value",
          "value": "CardWaitingListUX-Input-50"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeWaitingListSearch"
        },
        "placeholder": {
          "type": "value",
          "value": "ระบุชื่อ WaitingList"
        },
        "style": {
          "type": "code",
          "value": "{marginRight: \"10px\" , width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.waitingListSearch"
        }
      },
      "seq": 55,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 51,
      "name": "Button",
      "parent": 48,
      "props": {
        "color": {
          "type": "value",
          "value": "blue"
        },
        "icon": {
          "type": "value",
          "value": "refresh"
        },
        "id": {
          "type": "value",
          "value": "CardWaitingListUX-Button-51"
        },
        "loading": {
          "type": "code",
          "value": "props.waitingListLoading"
        },
        "onClick": {
          "type": "code",
          "value": "props.onRefresh"
        },
        "size": {
          "type": "value",
          "value": "small"
        },
        "style": {
          "type": "code",
          "value": "{marginRight: \"10px\"}"
        }
      },
      "seq": 51,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 52,
      "name": "Button",
      "parent": 49,
      "props": {
        "children": {
          "type": "value",
          "value": "สร้าง Waiting List",
          "valueEN": "Create a Waiting List"
        },
        "color": {
          "type": "value",
          "value": "blue"
        },
        "id": {
          "type": "value",
          "value": "CardWaitingListUX-Button-52"
        },
        "onClick": {
          "type": "code",
          "value": "props.onNewWaitingList"
        },
        "size": {
          "type": "value",
          "value": "small"
        },
        "style": {
          "type": "code",
          "value": "{...(props.hiddenCreateWaitingList && {display: \"none\"})}"
        }
      },
      "seq": 52,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 53,
      "name": "Dropdown",
      "parent": 46,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardWaitingListUX-Dropdown-53"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeWaitingListDivision"
        },
        "options": {
          "type": "code",
          "value": "props.divisionHasWaitingListOptions"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.selectedWaitingListDivisionId??\"\""
        }
      },
      "seq": 55,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 54,
      "name": "FormField",
      "parent": 44,
      "props": {
        "id": {
          "type": "value",
          "value": "CardWaitingListUX-FormField-54"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"14.9rem\"}"
        },
        "width": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 54,
      "void": false
    },
    {
      "from": null,
      "id": 55,
      "name": "label",
      "parent": 46,
      "props": {
        "children": {
          "type": "value",
          "value": "คลินิก",
          "valueEN": "clinic"
        },
        "id": {
          "type": "value",
          "value": "CardWaitingListUX-label-55"
        }
      },
      "seq": 53,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 56,
      "name": "Accordion",
      "parent": 0,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardWaitingListUX-Accordion-56"
        }
      },
      "seq": 20,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 57,
      "name": "AccordionTitle",
      "parent": 56,
      "props": {
        "active": {
          "type": "code",
          "value": "props.openAccordionAppointment"
        },
        "id": {
          "type": "value",
          "value": "CardWaitingListUX-AccordionTitle-57"
        },
        "onClick": {
          "type": "code",
          "value": "props.accordionAppointmentOnClick"
        },
        "style": {
          "type": "code",
          "value": "{paddingTop: \"0\"}"
        }
      },
      "seq": 57,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 58,
      "name": "AccordionContent",
      "parent": 56,
      "props": {
        "active": {
          "type": "code",
          "value": "props.openAccordionAppointment"
        },
        "id": {
          "type": "value",
          "value": "CardWaitingListUX-AccordionContent-58"
        }
      },
      "seq": 58,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 59,
      "name": "Icon",
      "parent": 37,
      "props": {
        "color": {
          "type": "code",
          "value": "props.selectedAppointment ?  \"grey\" : undefined"
        },
        "id": {
          "type": "value",
          "value": "CardWaitingListUX-Icon-59"
        },
        "name": {
          "type": "value",
          "value": "dropdown"
        }
      },
      "seq": 37,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 60,
      "name": "Button",
      "parent": 54,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "color": {
          "type": "value",
          "value": "teal"
        },
        "content": {
          "type": "value",
          "value": "สรุปรายชื่อเข้าคิว"
        },
        "icon": {
          "type": "value",
          "value": "right arrow"
        },
        "id": {
          "type": "value",
          "value": "CardWaitingListUX-Button-60"
        },
        "labelPosition": {
          "type": "value",
          "value": "right"
        },
        "onClick": {
          "type": "code",
          "value": "props.onClickSummaryQueueList"
        }
      },
      "seq": 60,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "isMounted": false,
  "memo": false,
  "name": "CardWaitingListUX",
  "project": "cudent2",
  "screenPropsDefault": {
    "patientSelector": "[Patient Selector]"
  },
  "width": 25
}

*********************************************************************************** */
